import { createAction, props } from '@ngrx/store';
import { UserProfile } from 'wre-authlib';

const PREFIX = '[User]';

export const userUpdate = createAction(
  `${PREFIX} Update`,
  props<{
    userProfile: UserProfile;
    permissions: string[];
    isUserSubscribed?: boolean;
  }>()
);

export const toggleUserSubscription = createAction(
  '[User] Toggle NotificationSubscription',
  props<{ email: string }>()
);

export const setUserSubscription = createAction(
  '[User] Set Notification Subscription',
  props<{ isUserSubscribed: boolean }>()
);
